<button
  type="{{ type }}"
  class="h3-bold btn btn-secondary btn-{{ size }} type-{{ Type }}"
  [disabled]="disabled"
  [ngClass]="{ focus: active === true }"
  aria-label="button"
  role="button"
  (click)="onClick.emit()">
  @if (['leftIcon', 'leftrightIcon', 'onlyIcon'].includes(Type)) {
    <span class="left-icon btn-icon d-flex">
      @if (social_icons.includes(IconType)) {
        <img alt="" src="../assets/{{ IconType }}.svg" />
      }
      @if (!social_icons.includes(IconType)) {
        <app-ce-icon
          [name]="IconType"
          [ngClass]="{ 'loader-spin': IconType == 'loader' }"
          [svg_class]="[
            'd-flex',
            ['microsoft', 'github', 'lock'].includes(IconType) ? 'primary-100' : 'primary-50',
          ]"></app-ce-icon>
      }
    </span>
  }

  @if (Type != 'onlyIcon' && label) {
    <span class="lable_name h3-bold text-nowrap">{{ label }}</span>
  }
  @if (IconValue) {
    <span class="key-btn right-icon h4-reg">{{ IconValue }}</span>
  }

  @if (['rightIcon', 'leftrightIcon'].includes(Type)) {
    <span class="btn-icon img-icon right-icon">
      @if (social_icons.includes(IconType)) {
        <img alt="" src="../assets/{{ IconType }}.svg" />
      }
      @if (!social_icons.includes(IconType)) {
        <app-ce-icon
          [name]="IconType"
          [ngClass]="{ 'loader-spin': IconType == 'loader' }"
          [svg_class]="[
            'd-flex',
            ['microsoft', 'github', 'lock'].includes(IconType) ? 'primary-100' : 'primary-50',
          ]"></app-ce-icon>
      }
    </span>
  }
</button>
<ng-content></ng-content>
